import { render, staticRenderFns } from "./WomensWellbeingStudio.vue?vue&type=template&id=3631af10"
import script from "./WomensWellbeingStudio.vue?vue&type=script&lang=js"
export * from "./WomensWellbeingStudio.vue?vue&type=script&lang=js"
import style0 from "./WomensWellbeingStudio.vue?vue&type=style&index=0&id=3631af10&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports